import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { SchemeModel } from '../models/scheme';

@Injectable({
    providedIn: 'root'
})
export class SchemesProvider {

    page = 1;
    getPaginationCount;
    schemes: SchemeModel[] = [];
    //   rewardSubCategories: RewardSubCategoryModel[] = [];
    //   rewardParentCategories = [];
    constructor(
        private apiService: ApiService,
        private toast: ToastClientService,
        private apiConfig: ApiConfiguration
    ) {
    }

    getSchemesList(): void {
        this.apiService.get(this.apiConfig.getSchemes).subscribe(
            (res: any) => {
                try{
                    this.schemes = res.data as SchemeModel[];
                }catch{

                }
            }
        );
    }

    addScheme(formData): void {
        this.apiService.post(this.apiConfig.addSchemes, formData)
        .subscribe((res:any)=>{
            formData.id = res.body.data.id;
            formData.config_flag = 0;
            this.schemes.push(formData);
            this.toast.Success('Scheme added successfully');
        },err=>{
            this.toast.Error(err.body.data.message);
        })
    }

}
